import React from "react";
import { Button } from "@/components/ui/button";
import { Share2, MessageCircle, Copy, Facebook } from "lucide-react";
import { toast } from "sonner";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export default function ShareButtons({ property }) {
  const url = `${window.location.origin}/property/${property.id}`;
  const priceFmt = (n) => {
    const v = Number(n);
    if (v >= 1_00_00_000) return `₹${(v / 1_00_00_000).toFixed(2)} Cr`;
    if (v >= 1_00_000) return `₹${(v / 1_00_000).toFixed(2)} L`;
    return `₹${v.toLocaleString("en-IN")}`;
  };
  const text = `🏡 ${property.title}\n📍 ${property.city}, ${property.state}\n💰 ${priceFmt(property.price_value)}\n📏 ${property.size_value} ${property.size_unit}\n\nDekhein: ${url}\n\n— BhoomiMitra • Ek Bhoomi Ek Mitra Ek Bharosa`;
  const enc = encodeURIComponent(text);
  const waUrl = `https://wa.me/?text=${enc}`;
  const fbUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;

  const nativeShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({ title: property.title, text, url });
      } catch (e) { void e; }
    } else {
      window.open(waUrl, "_blank");
    }
  };

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(url);
      toast.success("Link copied!");
    } catch {
      toast.error("Copy failed");
    }
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm" className="rounded-full" data-testid="share-btn">
          <Share2 size={14} className="mr-1.5" />Share
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem asChild data-testid="share-whatsapp">
          <a href={waUrl} target="_blank" rel="noreferrer" className="flex items-center gap-2 cursor-pointer">
            <MessageCircle size={14} className="text-emerald-600" /> WhatsApp
          </a>
        </DropdownMenuItem>
        <DropdownMenuItem asChild data-testid="share-facebook">
          <a href={fbUrl} target="_blank" rel="noreferrer" className="flex items-center gap-2 cursor-pointer">
            <Facebook size={14} className="text-blue-600" /> Facebook
          </a>
        </DropdownMenuItem>
        <DropdownMenuItem onSelect={copyLink} data-testid="share-copy" className="cursor-pointer">
          <Copy size={14} className="mr-2" /> Copy Link
        </DropdownMenuItem>
        {typeof navigator !== "undefined" && navigator.share && (
          <DropdownMenuItem onSelect={nativeShare} data-testid="share-native" className="cursor-pointer">
            <Share2 size={14} className="mr-2" /> More…
          </DropdownMenuItem>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
